import { Component } from '@angular/core';
import {MatSelectChange} from "@angular/material/select";
import {SingleSelectTableItemComponent} from "../single-select-table-item/single-select-table-item.component";

@Component({
  selector: 'app-multi-select-table-item',
  standalone: false,
  templateUrl: './multi-select-table-item.component.html',
  styleUrls: [
    '../../base-record-table-item-styles.scss',
    '../single-select-table-item/single-select-table-item.component.scss',
    './multi-select-table-item.component.scss'
  ]
})
export class MultiSelectTableItemComponent extends SingleSelectTableItemComponent {
  private isValueWasChanged: boolean = false;

  public preventClose(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public override handleSelectChange(event: MatSelectChange): void {
    this.value = event.value;
    this.isValueWasChanged = true;
  }

  public handleOpenedChange(isOpened: boolean): void {
    if (isOpened) { return; }
    if (!this.isValueWasChanged) { return; }

    super.handleValueChange(this.value);
    this.searchTerm = '';
    this.changeDetectorRef.markForCheck();
  }

  public isAllSelected(): boolean {
    if (!Array.isArray(this.value) || !this.selectData) { return false; }

    const validValues = this.value.filter(v => v !== undefined && v !== null);
    const validIds = this.selectData.map(item => item.id).filter(id => id !== undefined);

    return validValues.length === validIds.length &&
      validIds.every(id => validValues.includes(id));
  }

  public toggleSelectAll(): void {
    this.isValueWasChanged = true;
    this.value = this.isAllSelected() ?
      null :
      this.selectData?.filter(item => !!item.id)
        .map(item => item.id) || null;
  }

  public override getStringValue(): string {
    return this.columnParam.metaSelectKeyList!.filter((key: {id: number, value: string}) => {
      return !!(this.value as unknown as Array<number>)?.includes(key.id);
    }).map(key => key.value).join(', ');
  }
}
